import { render, staticRenderFns } from "./distribution_failed.vue?vue&type=template&id=347acbe6"
import script from "./distribution_failed.vue?vue&type=script&lang=js"
export * from "./distribution_failed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports